import React from 'react';
import Answer from './Answer';
import './../style/fonts.module.css'

const Question = ({
  libelle,
  type,
  choices,
  selectedAnswer,
  handleAnswerSelection,
}) => {
  return (
    <div className="mx-auto mt-8 mb-1 max-w-full md:max-w-[88%]">
      <h2 className="text-primary mb-1 text-center text-[clamp(18px,4vw,28px)] leading-[1.3] font-medium">
        {libelle}
      </h2>
      <div className="max-h-full">
        {choices.map((choice, index) => (
          <Answer
            key={index}
            choice={choice}
            index={index}
            onChange={(e) => handleAnswerSelection(e, index)}
            type={type}
            selectedAnswer={selectedAnswer}
          />
        ))}
      </div>
    </div>
  );
};

export default Question;